export default __webpack_public_path__ + "static/media/logo-stader.53a182f0.svg";